import { TermsSection1 } from '@/components/legal/TermsSection1';
import { TermsSection2 } from '@/components/legal/TermsSection2';
import { TermsSection3 } from '@/components/legal/TermsSection3';
import { TermsSection4 } from '@/components/legal/TermsSection4';

export const TermsOfServiceContent = () => {
  return (
    <div className="space-y-8">
      <TermsSection1 />
      <TermsSection2 />
      <TermsSection3 />
      <TermsSection4 />
    </div>
  );
};
